import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/locales";

export const useTranslation = () => {
  const { language } = useLanguage();
  const t = (key) => translations[language]?.[key] || translations.EN[key] || key;
  return { t, language };
};
